<style scoped>
	.mainblock:after {
		display: block;
		transform: rotate(90deg);
		position: relative;
		width: 100px;
		float: right;
		content: "РУБРИКАТОР";
		margin-top: -200px;
		margin-right: -67px;
		color: #777;
	}
</style>
<template>
	<div class="skillbox mainblock">
		<h5 v-if="title">{{title}}</h5>
		<div v-if="subtitle" class="subtitle">{{subtitle}}</div>
		<tags v-for="(item, idx) in tree"
			  :class="'root root-'+idx"
			  :key="idx+'_'+componentKey"
			  :data="item"
		/>
	</div>
</template>
<script>
	import "@/styles/ctags.css";
	import "@/styles/error.css";
	import Tags from "@/components/Tags/Tags.vue";
	import mixins from "@/components/Tags/mixins";

	//import '@riophae/vue-treeselect/dist/vue-treeselect.css'
	//import Treeselect from '@riophae/vue-treeselect'

	var $body = $('html');
	try {
		Vue.component('treeselect', window.VueTreeselect.Treeselect);
	}
	catch (e) {
		console.error(e)
	}

	export default {
		name: 'TagBlock',
		components: { Tags },
		mixins: [ mixins ],
		props: {
			title: { type: String, default: '' },
			subtitle: { type: String, default: '' },
			value: { type: Array, default: null },
			data: { type: Array, default: null },
		},
		data() {
			return {
				componentKey: 1,
				tree: this.data,
				selectedTags: new Set,
				//watch_value: true,
			}
		},
		created() {
			if (this.value) {
				this.setValues(this.tree, this.value);
			}
		},
		methods: {
			setValues(tree, selectedTags) {
				if (!selectedTags) return;
				for (let k in tree) {
					if (!tree.hasOwnProperty(k)) continue;
					if (selectedTags.includes(tree[k].id)) tree[k].selected = true;
					if (tree[k].children) {
						this.setValues(tree[k].children, selectedTags);
					}
				}
				this.forceReRender();
			},
			getAllSelectedTags() {
				this.selectedTags.clear();
				this.collectSelectedTags();
				return [...this.selectedTags];
				//let a = [...this.selectedTags];
				// this.watch_value = false;
				// this.$emit('input', a);
				// this.watch_value = true;
				//return a
			},
			collectSelectedTags() {
				this._collectSelectedTags(this.tree);
				this._collectSelectedTags2(this.$children);
			},
			_collectSelectedTags(data) {
				if (!data) return;
				for (let k in data) {
					if (!data.hasOwnProperty(k)) continue;
					if (data[k].selected) this.selectedTags.add(data[k].id);
					if (data[k].selectbox) continue;
					if (data[k].children) this._collectSelectedTags(data[k].children)
				}
			},
			_collectSelectedTags2(data) {
				if (!data) return;
				for (let k in data) {
					if (!data.hasOwnProperty(k)) continue;
					if (data[k].treeval) {
						for (let n in data[k].treeval) {
							if (!data[k].treeval.hasOwnProperty(n)) continue;
							this.selectedTags.add(data[k].treeval[n]);
						}
					}
					if (data[k].$children && data[k].$children.length) {
						this._collectSelectedTags2(data[k].$children);
					}
				}
			},
			/**
			 * Чисто на костылях тема
			 * смотрим только обязательный выбор минмума в рутовых тегах
			 */
			_collectSelectedFirstLevelTags() {
				let a = {};
				for (let k in this.$children) {
					if (!this.$children.hasOwnProperty(k)) continue;
					if (!this.$children[k].data.children) continue;
					if (!a[k]) a[k] = [];
					if (this.$children[k].treeval) {
						a[k].push(...this.$children[k].treeval);
					}
					for (let n in this.$children[k].data.children) {
						if (!this.$children[k].data.children.hasOwnProperty(k)) continue;
						if (this.$children[k].data.children[n].selected) {
							a[k].push(this.$children[k].data.children[n].id);
						}
					}
				}
				return a
			},
			isNotSelectedRootElements() {
				$('.tagbox.root.error-input').removeClass('error-input');
				let a = this._collectSelectedFirstLevelTags();
				for (let k in a) {
					if (!a.hasOwnProperty(k)) continue;
					if (!a[k].length) {
						let block = $('.root.root-' + k);
						block.addClass('error-input');
						$body.animate({ scrollTop: block.offset().top-70 }, 'slow');
						setTimeout(()=>{ block.removeClass('error-input') }, 1e4);
						return true
					}
				}
				return false
			},
		},
		watch: {
			value(value) {
				//if (!this.watch_value) return;
				this.setValues(this.tree, value);
			}
		}
	}
</script>